<template>
    <div class="share-wrap" v-if="show" @click="toClose">
        <div :class="['share-panel',{'show':showPopup}]" @click.stop="()=>{}">
            <img class="close" src="@/assets/images/project/v3/close_icon.png" @click="toClose"></img>
            <div class="share-box">
                <div class="title">分享方式</div>
                <template v-for="item in arrShareMethod">
                    <div class="share-item">
                        <img :src="item.icon" alt="">
                        <div class="name">{{ item.name }}</div>
                        <div v-if="item.key == 'link'" class="btn" id="express"
                             @click="toShare($event,item.key)">
                            {{ item.button }}
                        </div>
                        <div v-else class="btn" :id="item.id" @click="toShare($event,item.key)">
                            {{ item.button }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <!-- 项目分享海报 -->
        <!-- <div id="case_poster" ref="case_poster" class="poster-panel">
            <img class="top-pic" alt="">
            <div class="info-box">
                <div class="info-item">
                    <p class="value">{{ '190' || '&#45;&#45;' }} ㎡</p>
                    <p class="label">建筑面积</p>
                </div>
                <div class="info-item">
                    <p class="value">{{ '5室3厅' }}</p>
                    <p class="label">房型</p>
                </div>
                <div class="info-item">
                    <p class="value">{{ '复式' }}</p>
                    <p class="label">房屋类型</p>
                </div>
                <div class="info-item">
                    <p class="value">{{ '智能集成系统' }}</p>
                    <p class="label">案例类型</p>
                </div>
            </div>
            <div class="qrcode-box">
                <div class="name">{{ '上海市' }}｜{{ '崇明区南昌路' }}</div>
                <div class="desc">AI-LiNK冷暖风水专业集成项目案例</div>
                <div class="qrcode-pic" id="case_qrcode" ref="case_qrcode">
                </div>
                <div class="qrcode-desc">扫码查看案例详情</div>
                <div class="qrcode-desc2">中央空调 · 采暖 · 新风 · 全屋用水</div>
            </div>
        </div>
        <div v-if="showPoster" @click.stop="toClosePoster" class="poster-pic">
            <img :src="posterPic" alt="" @click.stop="()=>{}">
            <div class="btn">长按图片保存到相册</div>
        </div>-->
        <!-- 评论分享海报 -->
        <div class="poster-panel" ref="poster_canvas" id="capture">
            <div class="top-title">
                <div v-if="isDiscuss" class="title1">
                    AL-LiNK高端智慧集成系统
                </div>
                <div v-else class="title2">
                    AL-LiNK高端智慧集成系统
                </div>
                <div v-if="isDiscuss" class="title3">
                    用户真实体验
                </div>
                <div v-else class="title2">
                    专业一站式服务
                </div>
                <template v-if="isDiscuss">
                    <div class="text">
                        “{{ objPoster.poster_title || '很满意史密斯这次的服务，采暖、 空调效果也非常好' }}”
                    </div>
                    <div class="name">
                        {{ '—— ' + (objPoster.city || '--') + '用户 ' + (objPoster.name || '--') }}
                    </div>
                </template>
            </div>
            <div v-if="isDiscuss" class="poster-bgc">
                <img class="img" v-if="objPoster.poster_pic" :src="objPoster.poster_pic" alt=""/>
                <img class="img" v-else
                     src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/top-bgc.png"/>
            </div>
            <div v-else class="poster-bgc">
                <template v-for="(item,index) in images">
                    <img class="img2" v-if="index <= 1 && item.image_url" :src="item.image_url" alt=""/>
                </template>
            </div>
            <div class="title">
                {{ (houseInfo.city || '--') + ' ｜ ' + (houseInfo.community_name || '--') }}
            </div>
            <div class="info">
                <div class="info-item">
                    <img class="img"
                         src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/rl.png"/>
                    <div class="span span3">
                        {{ houseInfo.created_at || '--' }}
                    </div>
                </div>
                <div v-if="houseInfo.house_cate" class="info-item">
                    <img class="img"
                         src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/bs.png"/>
                    <div class="span">
                        {{ houseInfo.house_cate }}
                    </div>
                </div>
                <div v-if="houseInfo.house_area" class="info-item">
                    <img class="img"
                         src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/mj.png"/>
                    <div class="span span2">
                        {{ houseInfo.house_area }}
                    </div>
                </div>
            </div>
            <div class="qr-wrap">
                <div class="qr-left">
                    <div class="top-qr">
                        <div class="name"> {{ houseInfo.nickname || '--' }}</div>
                        <div class="tag">高级服务顾问</div>
                    </div>
                    <div class="b-qr">
                        <div>长按识别</div>
                        <div>了解{{ isDiscuss ? '用户真实体验' : '专业一站式服务' }}</div>
                    </div>
                </div>
                <div class="qr-right" id="poster-qrcode" ref="poster_qrcode"></div>
                <div class="qr-head">
                    <img :src="houseInfo.headimgurl" alt="">
                </div>
            </div>
            <div class="b-bg">
                <div class="logo-img">
                    <img src="@/assets/images/share/logo2.png" alt="">
                    <span>AI-LiNK好风好水智慧互联</span>
                </div>
                <div class="sp">
                    <img src="@/assets/images/share/sp3.png" alt="">
                </div>
            </div>
        </div>
        <div v-if="showPoster" @click.stop="toClosePoster" class="poster-pic">
            <img :src="posterPic" alt="" @click.stop="()=>{}">
            <img class="close" @click.stop="toClosePoster" src="@/assets/images/share/close_icon.png" alt="">
            <div class="tips">*长按保存图片<br/>*朋友圈文字已复制</div>
        </div>
    </div>
</template>
<script>
import {Toast} from "mint-ui";
import QRCode from "qrcodejs2";
import html2canvas from "@/libsV2/html2canvas";
import {getPosterInfo} from "@/js/project/v3/index.js";


export default {
    name: 'sharePanel',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        shareConfig: {
            type: Object,
            default: {}
        },
        projectId: {
            type: String,
            default: ''
        },
        isDiscuss: {
            type: Boolean,
            value: false
        },
        images: {
            type: Array,
            value: []
        },
        houseInfo: {
            type: Object,
            value: {}
        }
    },
    data() {
        return {
            // 分享方式
            arrShareMethod: [
                // {
                //     icon: require("@/assets/images/project/v3/share_link.png"),
                //     key: "link",
                //     name: "链接分享到朋友圈",
                //     button: "复制",
                // },
                {
                    icon: require("@/assets/images/project/v3/share_common.png"),
                    key: "share",
                    name: "分享链接",
                    button: "分享",
                }, {
                    icon: require("@/assets/images/project/v3/share_qrcode.png"),
                    key: "banner",
                    name: "生成海报",
                    button: "生成海报",
                }
            ],
            showPopup: false,
            showPoster: false,
            posterPic: '',
            objPoster: {}
        };
    },
    mounted() {
    },
    watch: {
        show(value) {
            if (value) {
                setTimeout(() => {
                    this.showPopup = true;
                }, 50)
            } else {
                this.showPopup = false;
            }
        }
    },
    methods: {
        toClose() {
            this.$emit('close')
        },
        toShare(e, key) {
            this.$common.pushEvent('project_share_discuss', this.projectId);
            let that = this;
            let confit = that.shareConfig;
            switch (key) {
                case 'link':
                    // 创建模拟 输入框
                    var cInput = document.createElement("input");
                    // cInput.value = `${window.location.origin}/project/v3/case/details?mode=2`;
                    cInput.value = confit.share_link;
                    document.body.appendChild(cInput);
                    cInput.select(); // 选取文本框内容
                    // 执行浏览器复制命令
                    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
                    // Input要在正常的编辑状态下原生复制方法才会生效
                    document.execCommand("copy");
                    // 复制成功后再将构造的标签 移除
                    document.body.removeChild(cInput);
                    that.$toast({
                        message: "复制成功",
                        duration: 1200,
                    });
                    break;
                case 'share':
                    // this.$common.pushEvent('project_share_discuss', this.$route.query.id);
                    /*let wechat = this.$storage.getStorage("is_wechat");
                    if (wechat == 1) {
                        this.$toast({
                            message: "请点击右上角···转发哦~",
                            className: 'toast-max'
                        });
                    } else if (wechat == 6) {
                        this.getQyhh();
                    } else {
                        this.$toast({
                            message: "请点击右上角···转发哦~",
                            className: 'toast-max'
                        });
                    }*/

                    var ua = window.navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        if (ua.match(/WxWork/i) == "wxwork") {
                            //企业微信环境下
                            if (wx?.miniProgram?.getEnv) {
                                wx.miniProgram.getEnv(function (res) {
                                    if (res.miniprogram) {
                                        // 小程序环境下逻辑
                                        that.$toast({
                                            message: "请点击右上角···转发哦~",
                                            className: 'toast-max'
                                        });
                                    } else {
                                        //非小程序环境下逻辑
                                        let wechat = that.$storage.getStorage("is_wechat");
                                        if (wechat == 6) {
                                            that.getQyhh();
                                        } else {
                                            that.$toast({
                                                message: "请点击右上角···转发哦~",
                                                className: 'toast-max'
                                            });
                                        }
                                    }
                                });
                            } else {
                                that.$toast({
                                    message: "请点击右上角···转发哦~",
                                    className: 'toast-max'
                                });
                            }
                        } else {
                            //判断是否是微信环境
                            //微信环境
                            that.$toast({
                                message: "请点击右上角···转发哦~",
                                className: 'toast-max'
                            });
                        }
                    } else {
                        that.$toast({
                            message: "请点击右上角···转发哦~",
                            className: 'toast-max'
                        });
                    }
                    break;
                case 'banner':
                    // 创建模拟 输入框
                    var cInput = document.createElement("input");
                    // cInput.value = `${window.location.origin}/project/v3/case/details?mode=2`;
                    cInput.value = 'A.O.史密斯AI-LiNK好风好水智慧集成系统真实用户体验，快扫码识别查看吧~';
                    document.body.appendChild(cInput);
                    cInput.select(); // 选取文本框内容
                    // 执行浏览器复制命令
                    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
                    // Input要在正常的编辑状态下原生复制方法才会生效
                    document.execCommand("copy");
                    // 复制成功后再将构造的标签 移除
                    document.body.removeChild(cInput);

                    //清空二维码
                    that.$refs.poster_qrcode.innerHTML = '';
                    that.$store.commit("loadSwitch", true);

                    this.getPosterInfoFun().then(() => {
                        setTimeout(() => {
                            that.qrcode = new QRCode(that.$refs.poster_qrcode, {
                                text: confit.share_link, //页面地址 ,如果页面需要参数传递请注意哈希模式#
                                width: 148,
                                height: 148,
                                colorDark: '#333',//二维码颜色
                                colorLight: '#fff',//二维码背景颜色
                                correctLevel: QRCode.CorrectLevel.L//容错率,L/M/H
                            })

                            setTimeout(() => {
                                let sHeight = that.$refs.poster_canvas.offsetHeight;
                                let sWidth = that.$refs.poster_canvas.offsetWidth;
                                html2canvas(that.$refs.poster_canvas, {
                                    allowTaint: true, // 允许跨域图片
                                    useCORS: true,
                                    height: sHeight,
                                    width: sWidth,
                                    x: 2 * window.innerWidth,
                                    y: 0,
                                    scrollX: 0,
                                    scrollY: 0,
                                    dpi: window.devicePixelRatio,
                                    scale: 2,
                                }).then((canvas) => {
                                    const imgData = canvas.toDataURL("image/png");
                                    that.posterPic = imgData
                                    that.showPoster = true;
                                    that.showPopup = false;
                                    console.log('----')
                                    that.$store.commit("loadSwitch", false);
                                });
                            }, 1000)
                        }, 500)
                    })
                    break;
            }
        },
        getQyhh() {
            this.$store.commit("loadSwitch", true);
            let that = this;
            let confit = this.shareConfig;
            //分享到会话
            wx.ready(() => {
                wx.invoke("getContext", {}, function (res) {
                    that.$store.commit("loadSwitch", false);
                    //  console.log("分享到会话", res);
                    if (res.err_msg == "getContext:ok") {
                        let entry = res
                            .entry; //返回进入H5页面的入口类型，目前有normal、contact_profile、single_chat_tools、group_chat_tools
                        if (entry == "normal") {
                            wx.invoke(
                                "shareAppMessage", {
                                    title: confit.share_friend_title, // 分享标题
                                    desc: confit.share_friend_desc, // 分享描述
                                    imgUrl: confit.share_img_url, // 分享封面
                                    link: confit.share_link, // 分享链接
                                },
                                function (res) {
                                    //  console.log("企业微信会话", res);
                                    if (res.err_msg == "shareAppMessage:ok") {
                                        // that.$emit("update:bShowNrom", false);
                                    } else if (
                                        res.err_msg == "shareAppMessage:cancel"
                                    ) {
                                        // that.$emit("update:bShowNrom", false);
                                    }
                                }
                            );
                        } else if (
                            entry == "single_chat_tools" ||
                            entry == "group_chat_tools"
                        ) {
                            wx.invoke(
                                "sendChatMessage", {
                                    msgtype: "news", //消息类型，必填
                                    news: {
                                        link: confit.share_link, //H5消息页面url 必填
                                        title: confit.share_friend_title, //H5消息标题
                                        desc: confit.share_friend_desc, //H5消息摘要
                                        imgUrl: confit.share_img_url, //H5消息封面图片URL
                                    },
                                },
                                function (res) {
                                    //  console.log("服务指引返回结果", res);
                                    if (res.err_msg == "sendChatMessage:ok") {
                                        // that.$emit("update:bShowNrom", false);
                                        //发送成功
                                    } else if (
                                        res.err_msg == "shareAppMessage:cancel"
                                    ) {
                                        // that.$emit("update:bShowNrom", false);
                                    }
                                }
                            );
                        }
                    } else {
                        //  console.log("错误处理");
                        //错误处理
                    }
                });
            });
        },
        getPosterInfoFun() {
            return new Promise((resolve, reject) => {
                if (this.isDiscuss) {
                    getPosterInfo({
                        project_uuid: this.projectId,
                    }).then((res) => {
                        this.objPoster = res.data.data.result;
                        this.objPoster.date = this.objPoster.date ? this.objPoster.date.split(' ')[0] : '';
                        resolve()
                    }).catch(()=>{
                        reject()
                    })
                } else {
                    resolve()
                }
            })
        },
        toClosePoster() {
            this.showPoster = false;
            this.$emit('close')
        }
    },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
